var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.yuri)?_c('PrivateSystem',{attrs:{"msg":"Private System"}}):_vm._e(),(_vm.starlitedge)?_c('StarlitEdge'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }